import _ from 'lodash';
import CalculatorSelectInput from '../../../../calculatorInputs/CalculatorSelectInput';
import i18next from 'i18next';
import {
  AttributeType,
  REGEXP_DECIMAL,
  REGEXP_INTEGER,
  REGEXP_PERCENTAGE,
} from '../../../../../../../../services/common/Constants';
import CalculatorStandardInput from '../../../../calculatorInputs/CalculatorStandardInput';
import React from 'react';

const EqualValue = ({
  selectedFieldSubType,
  availableValueOptions,
  fieldName,
  showLabel,
  readOnly = false
}) => {
  const label = showLabel
    ? i18next.t('calculator.dialog.create.label.values')
    : '';
  const placeholder = i18next.t(
    'calculator.dialog.create.placeholder.selectValues'
  );

  const validate = (value) => {
    if (!value) return null;
    switch (selectedFieldSubType) {
      case AttributeType.INTEGER:
        return !REGEXP_INTEGER.test(value)
          ? i18next.t('attributes.errors.integer')
          : null;
      case AttributeType.DECIMAL:
        return !REGEXP_DECIMAL.test(value)
          ? i18next.t('attributes.errors.decimal')
          : null;
      case AttributeType.PERCENTAGE:
        return !REGEXP_PERCENTAGE.test(value)
          ? i18next.t('attributes.errors.percentage')
          : null;
      default:
        return null;
    }
  };

  const commonProps = {
    fieldName: `${fieldName}.0`,
    isRequired: true,
    label,
    placeholder,
    validate,
    uxVariant: 'criteriaInput',
    variant: 'standard',
  };

  return !_.isEmpty(availableValueOptions) ? (
    <CalculatorSelectInput
      {...commonProps}
      options={availableValueOptions}
      labelVariant="chip"
      disabled={readOnly}
      triggerOnContinue
    />
  ) : (
    <CalculatorStandardInput {...commonProps} triggerOnContinue disabled={readOnly}/>
  );
};

export default EqualValue;
